import React, { useState, useEffect, useRef } from 'react';
import { Link } from 'react-router-dom';
import './Credentials.css';
import Footer from '../../components/Footer';
import NextPageCTA from '../../components/NextPageCTA';
import BannerLogo from '../../components/BannerLogo';
import credentials from '../../assets/images/Credentials.webp';
// Import Font Awesome icons
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { 
  faCheckCircle, 
  faBuilding, 
  faDatabase, 
  faNetworkWired, 
  faServer, 
  faCloud,
  faCodeBranch,
  faShieldAlt,
  faArrowDown,
  faChevronDown,
  faChartLine,
  faUsers,
  faAward,
  faProjectDiagram,
  faClock,
  faClipboardCheck,
  faCalendarAlt,
  faListAlt,
  faPercentage
} from '@fortawesome/free-solid-svg-icons';

// Import stat images
import ProjectsImage from '../../assets/images/projects.jpg';
import YearsExperienceImage from '../../assets/images/years experience.jpg';
import IndustryClientsImage from '../../assets/images/industry-clients.jpg';

// Import company logos
import EssarLogo from '../../assets/logos/Essar.jpeg';
import VedantaLogo from '../../assets/logos/Vedanta.jpg';
import AmwLogo from '../../assets/logos/AMW.jpg';
import SterliteLogo from '../../assets/logos/Sterlite.png';
import MittalLogo from '../../assets/logos/Mittal.jpg';
import KalyaniLogo from '../../assets/logos/Kalyani.webp';
import GerdauLogo from '../../assets/logos/Gerdau.jpeg';
import JswLogo from '../../assets/logos/JSW.png';
import DbPowerLogo from '../../assets/logos/DB Power.jpeg';
import TalwandiLogo from '../../assets/logos/Talwandi Sabo.jpg';
import UshaMartinLogo from '../../assets/logos/Usha Martin.png';

// Import project images
import ProjectImage1 from '../../assets/images/capitalization.jpg';
import ProjectImage2 from '../../assets/images/asset value.jpg';
import ProjectImage3 from '../../assets/images/residual value.jpg';
import ProjectImage4 from '../../assets/images/Physical Verification.jpg';

// Import sector logos
import BALCO from '../../assets/General Engg/BALCO.jpg';
import RFCL from '../../assets/General Engg/RFCL.jpg';
import VedantaGeneral from '../../assets/General Engg/Vedanta.jpg';
import DCWDhangradhra from '../../assets/General Engg/DCW Dhangradhra.png';
import DeepakPhenolics from '../../assets/General Engg/Deepak Phenolics.jpeg';
import Maharaja from '../../assets/General Engg/Maharaja.png';

import Nayara from '../../assets/Oil/Nayara.jpg';
import ONGC from '../../assets/Oil/ONGC.png';
import HMEL from '../../assets/Oil/HMEL.jpg';
import OPAL from '../../assets/Oil/OPAL.png';

import DBPower from '../../assets/Power/DB Power.jpg';
import Adani from '../../assets/Power/adani.jpg';
import JSWEnergy from '../../assets/Power/JSW Energy.png';
import TSPL from '../../assets/Power/TSPL.png';

import EssarSteel from '../../assets/Steel/Essar Steel.png';
import ArcelorMittal from '../../assets/Steel/Arcelor Mittal.png';
import BPSL from '../../assets/Steel/BPSL.png';
import UshaMartinSteel from '../../assets/Steel/UshaMartin.png';
import JSWSteel from '../../assets/Steel/JSW Steel.png';

const Credentials = () => {
  // Data for credential cards with complete content - Moved to the top before state declarations
  const credentialCards = [
    {
      id: 1,
      title: "Capitalization of Property Plant & Equipment",
      icon: "building",
      color: "#3498db",
      projects: [
        "ESSAR Oil Ltd – 14 MMTPA Oil Refinery at Vadinar, Gujarat",
        "ESSAR Oil Ltd – Expansion of the Oil Refinery to 20 MMTPA.",
        "VADINAR Oil Terminal Ltd. – Major items include Jetty, Pipelines and Tankages etc",
        "VADINAR Power Co Ltd. – Co-gen Power Plant of 120 MWe in Phase 1 and 510 MWe in Phase 2.",
        "VEDANTA Aluminium Ltd – Aluminium Smelting Plant, Jharsuguda, Orissa",
        "VEDANTA Alumina Ltd. – Aluminium Refinery at Lanjigar, Orissa",
        "Asia Motor Works Ltd – Commercial Vehicles Plant including Auto Component Division at Bhuj, Gujarat.",
        "Sterlite Energy Ltd – 4 x 600 MW Independent Power Plant at Jharsuguda, Orissa",
        "HPCL Mittal Energy Ltd – 9.0 MMTPA Oil Refinery at Bhatinda, Punjab",
        "Kalyani Gerdau Steel Ltd – Determination of Fair Value of 0.3 MMTPA Steel Plant at Tadipatri, AP.",
        "JSW Steel Ltd – 7.0 and 10.0 MMTPA Steel Plant expansion at Vijanagar, Karnataka.",
        "Essar Power Gujarat Ltd – 2 x 600 MW Coal Based Power Plant at Salaya, Gujarat.",
        "Essar Power MP Ltd – 2 x 600 MW Coal Based Power Plant at Mahan, MP.",
        "Essar Power Transmission Co Ltd – Transmission Lines",
        "Gerdau Steel India Ltd – Expansion of Steel Plant capacity at Tadipatri, AP",
        "DB Power Ltd – 2 x 600 MW Coal Based Power Plant near Raipur, Chattisgarh (In progress)",
        "Talwandi Sabo Power Ltd – 3 x 660 MW Coal Based Power Plant near Mansa, Bhatinda, Punjab (In Progress)",
        "JSW Energy Ltd for their power plants located at Vijaynagar and Ratnagiri.",
        "Raj West Power Ltd for their power plant at Barmer, Rajasthan.",
        "Essar Power Hazira Ltd – 2 x 135 MW Thermal Power Plant (in progress)",
        "Essar Power Orissa Ltd – 4 x 30 MW Thermal Power Plant (in progress)"
      ]
    },
    {
      id: 2,
      title: "Asset Valuation As Per IFRS Requirements",
      icon: "chart-line",
      color: "#e74c3c",
      description: "Determination of Fair Value of Property Plant & Equipment as per IFRS",
      companyHeading: "ESSAR Global Ltd., the holding arm of various companies which include:",
      companies: [
        "ESSAR Steel Ltd and other Steel Companies of ESSAR",
        "ESSAR Power Ltd and other Power Companies of ESSAR",
        "ESSAR Oil Ltd;",
        "ESSAR Oilfield Services Ltd",
        "Vadinar Oil Terminal Ltd",
        "ESSAR Constructions India Ltd",
        "ESSAR Shipping Ltd",
        "ESSAR Ports and Logistics Ltd"
      ],
      otherProjects: [
        "JSW Steel Ltd for their plants located at Vijaynagar, Salem, Tarapur and Vasind",
        "Vedanta Aluminium Ltd for their plants located at Jharsuguda and Lanjigarh",
        "Gerdau Steel India Ltd for their plant located at Tadipatri, AP"
      ]
    },
    {
      id: 3,
      title: "Assessment of Useful Life & Residual Value",
      icon: "clock",
      color: "#2ecc71",
      projects: [
        "Essar Oil Ltd – for 20 MMTPA Refinery at Vadinar, Gujarat",
        "JSW Steel Ltd – for their Steel Plants at Vijaynagar, Salem, Dolvi and Salav and ARCL",
        "Essar Steel Ltd - for their Steel Plants at Hazira, Visakhapatnam and Kirandul",
        "Usha Martin Ltd – for their Steel Plant at Jamshedpur",
        "Vadinar Oil Terminal Ltd, Vadinar",
        "Vadinar Ports & Terminal Ltd, Vadinar"
      ]
    },
    {
      id: 4,
      title: "Audit & Physical Verification",
      icon: "clipboard-check",
      color: "#f39c12",
      projects: [
        "HPCL Mittal Energy Ltd – Estimate, Audit and Physical Verification of Civil and Structural Quantities for CDSP Project in Delayed Coker Unit at Bhatinda, Punjab.",
        "Essar Projects Ltd – Construction material stock verification at various project locations all over the country",
        "Essar Oil Ltd – Physical Verification of Fixed Assets and Reconciliation of Fixed Assets Register for 20 MMTPA Refinery at Vadinar, Gujarat."
      ]
    }
  ];

  // Add this constant after your credentialCards array
  const indicationItems = [
    {
      icon: faCalendarAlt,
      text: "Schedule II to the 2013 Act enshrines within itself the principle for recognizing depreciation on the assets over their useful lives"
    },
    {
      icon: faListAlt,
      text: "Part C of the Schedule II to the 2013 Act lays down indicative useful lives of certain tangible assets"
    },
    {
      icon: faClock,
      text: "Useful life of tangible assets should not be ordinarily different from the useful life specified in Part C of the Schedule II to the 2013 Act"
    },
    {
      icon: faPercentage,
      text: "Residual value should not be more than 5% of the original cost of the tangible assets"
    }
  ];

  const [activeCard, setActiveCard] = useState(1);
  const [activeTabLine, setActiveTabLine] = useState(1);
  const [panelColor, setPanelColor] = useState(credentialCards[0].color);
  const [isVisible, setIsVisible] = useState(false);
  const [scrollY, setScrollY] = useState(0);
  const projectsRef = useRef(null);
  const heroRef = useRef(null);
  const statsRef = useRef(null);

  // Add refs for each stat number
  const projectsCountRef = useRef(null);
  const yearsCountRef = useRef(null);
  const clientsCountRef = useRef(null);
  
  // Track animation state - change to track visibility instead of animation completed
  const [isStatsVisible, setIsStatsVisible] = useState(false);
  const [animationInProgress, setAnimationInProgress] = useState(false);

  // Function to check if an element is in viewport
  const isElementInViewport = (el) => {
    if (!el) return false;
    
    const rect = el.getBoundingClientRect();
    return (
      rect.top < window.innerHeight * 0.8 &&
      rect.bottom >= 0
    );
  };

  useEffect(() => {
    setIsVisible(true);
    
    const handleScrollEvent = () => {
      setScrollY(window.scrollY);
      
      // Check if stats section is in viewport
      if (statsRef.current) {
        const isInView = isElementInViewport(statsRef.current);
        
        // If status changed (either entering or leaving viewport)
        if (isInView !== isStatsVisible) {
          setIsStatsVisible(isInView);
          
          // If coming into view and no animation is running
          if (isInView && !animationInProgress) {
            startCounterAnimations();
          }
        }
      }
    };
    
    // Explicitly check for visibility on component mount
    setTimeout(() => {
      handleScrollEvent();
    }, 1000);
    
    window.addEventListener('scroll', handleScrollEvent);
    
    return () => {
      window.removeEventListener('scroll', handleScrollEvent);
    };
  }, [isStatsVisible, animationInProgress]);

  // Animation function for counting
  const animateValue = (obj, start, end, duration) => {
    if (!obj) {
      return;
    }
    
    // Add counting class at start of animation
    obj.classList.add('counting');
    
    // Parse the numeric part from end if it's a string like "150+"
    let numericEnd = end;
    let suffix = '';
    
    if (typeof end === 'string') {
      const match = end.match(/^(\d+)(.*)$/);
      if (match) {
        numericEnd = parseInt(match[1], 10);
        suffix = match[2];
      }
    }
    
    // Ensure we have a valid number
    numericEnd = Number(numericEnd);
    if (isNaN(numericEnd)) {
      numericEnd = 0;
    }
    
    let startTimestamp = null;
    const step = (timestamp) => {
      if (!startTimestamp) startTimestamp = timestamp;
      const progress = Math.min((timestamp - startTimestamp) / duration, 1);
      const currentValue = Math.floor(progress * (numericEnd - start) + start);
      
      // Display the current value with suffix as superscript
      obj.innerHTML = currentValue + (suffix ? `<sup>${suffix}</sup>` : '');
      
      if (progress < 1) {
        window.requestAnimationFrame(step);
      } else {
        obj.innerHTML = numericEnd + (suffix ? `<sup>${suffix}</sup>` : '');
        // Remove counting class when animation is complete
        obj.classList.remove('counting');
        
        // Signal that animation is complete
        setAnimationInProgress(false);
      }
    };
    window.requestAnimationFrame(step);
  };

  // Function to start all counter animations
  const startCounterAnimations = () => {
    // Don't start if animation is already running
    if (animationInProgress) return;
    
    // Set animation in progress
    setAnimationInProgress(true);
    
    // Reset counters to zero first
    if (projectsCountRef.current) projectsCountRef.current.innerHTML = "0";
    if (yearsCountRef.current) yearsCountRef.current.innerHTML = "0";
    if (clientsCountRef.current) clientsCountRef.current.innerHTML = "0";
    
    // Force a small delay to ensure the reset is visible
    setTimeout(() => {
      // Start animations with different durations for variety
      animateValue(projectsCountRef.current, 0, "150+", 2000);
      animateValue(yearsCountRef.current, 0, "20+", 1500);
      animateValue(clientsCountRef.current, 0, "50+", 1800);
    }, 50);
  };

  const scrollToProjects = () => {
    if (projectsRef.current) {
      projectsRef.current.scrollIntoView({ behavior: 'smooth' });
    } else {
      // Fallback - scroll down 600px
      window.scrollTo({
        top: 600,
        behavior: 'smooth'
      });
    }
  };

  const handleTabClick = (tabId) => {
    setActiveCard(tabId);
    setActiveTabLine(tabId);
    // Set the panel color based on the clicked tab
    const selectedCard = credentialCards.find(card => card.id === tabId);
    setPanelColor(selectedCard.color);
  };

  // Map company names to logos
  const getCompanyLogo = (projectName) => {
    if (projectName.includes('ESSAR') || projectName.includes('Essar')) return EssarLogo;
    if (projectName.includes('VEDANTA') || projectName.includes('Vedanta')) return VedantaLogo;
    if (projectName.includes('Asia Motor') || projectName.includes('AMW')) return AmwLogo;
    if (projectName.includes('Sterlite')) return SterliteLogo;
    if (projectName.includes('HPCL Mittal') || projectName.includes('Mittal')) return MittalLogo;
    if (projectName.includes('Kalyani')) return KalyaniLogo;
    if (projectName.includes('Gerdau')) return GerdauLogo;
    if (projectName.includes('JSW')) return JswLogo;
    if (projectName.includes('DB Power')) return DbPowerLogo;
    if (projectName.includes('Talwandi')) return TalwandiLogo;
    if (projectName.includes('Usha Martin')) return UshaMartinLogo;
    if (projectName.includes('VADINAR')) return EssarLogo; // Use Essar logo for VADINAR as they're related
    
    // Default fallback to building icon if no logo matches
    return null;
  };

  // Add this function before the return statement
  const getProjectImage = (projectName) => {
    // Return appropriate image based on project type/name
    if (projectName.includes('Refinery') || projectName.includes('Oil')) {
      return ProjectImage2;
    } else if (projectName.includes('Power') || projectName.includes('Energy')) {
      return ProjectImage3;
    } else if (projectName.includes('Steel')) {
      return ProjectImage1;
    } else if (projectName.includes('Verification') || projectName.includes('Audit')) {
      return ProjectImage4;
    }
    // Default to first image if no match
    return ProjectImage1;
  };

  return (
    <div className="credentials-page">
      {/* Credentials Hero Carousel Section */}
      <div className="credentials-hero">
        <div className="credentials-hero-logo-wrapper">
          <BannerLogo />
        </div>
        <img 
          src={credentials}
          alt="Credentials Banner" 
          className="credentials-hero-image" 
        />
        <div className="credentials-hero-overlay"></div>
        <h1 className="credentials-heading">Our Credentials</h1>
      </div>

      {/* Statistics Section - Moved just below hero section */}
      <section className={`stats-section ${isVisible ? 'visible' : ''}`} ref={statsRef}>
        <div className="container">
          <div className="stats-grid">
            <div className="stat-card">
              <img src={ProjectsImage} alt="Projects Completed" className="stat-card-image" />
              <div className="stat-number" ref={projectsCountRef}>0</div>
              <div className="stat-label">Projects Completed</div>
            </div>
            <div className="stat-card">
              <img src={YearsExperienceImage} alt="Years Experience" className="stat-card-image" />
              <div className="stat-number" ref={yearsCountRef}>0</div>
              <div className="stat-label">Years Experience</div>
            </div>
            <div className="stat-card">
              <img src={IndustryClientsImage} alt="Industry Clients" className="stat-card-image" />
              <div className="stat-number" ref={clientsCountRef}>0</div>
              <div className="stat-label">Industry Clients</div>
            </div>
          </div>
        </div>
      </section>

      {/* Industries Section - moved here to appear below stats section */}
      <section className={`industries-section ${isVisible ? 'visible' : ''}`}>
        <div className="container">
          <div className="section-header">
            <h2 className="section-title">Industries We Serve</h2>
            <p className="section-subtitle">
              We offer services to clients operating in a broad spectrum of industries
            </p>
          </div>
          <div className="industries-grid">
            {/* First Row */}
            <div className="industry-card">
              <div className="industry-icon">
                <i className="fas fa-industry"></i>
              </div>
              <h3>Steel</h3>
            </div>
            <div className="industry-card">
              <div className="industry-icon">
                <i className="fas fa-oil-can"></i>
              </div>
              <h3>Oil & Gas</h3>
            </div>
            <div className="industry-card">
              <div className="industry-icon">
                <i className="fas fa-bolt"></i>
              </div>
              <h3>Energy</h3>
            </div>
            <div className="industry-card">
              <div className="industry-icon">
                <i className="fas fa-hard-hat"></i>
              </div>
              <h3>Construction</h3>
            </div>
            <div className="industry-card">
              <div className="industry-icon">
                <i className="fas fa-flask"></i>
              </div>
              <h3>Fertilizer</h3>
            </div>
            {/* Second Row */}
            <div className="industry-card">
              <div className="industry-icon">
                <i className="fas fa-scroll"></i>
              </div>
              <h3>Paper</h3>
            </div>
            <div className="industry-card">
              <div className="industry-icon">
                <i className="fas fa-cubes"></i>
              </div>
              <h3>Cement</h3>
            </div>
            <div className="industry-card">
              <div className="industry-icon">
                <i className="fas fa-cookie"></i>
              </div>
              <h3>Sugar</h3>
            </div>
            <div className="industry-card">
              <div className="industry-icon">
                <i className="fas fa-car"></i>
              </div>
              <h3>Automobiles</h3>
            </div>
            <div className="industry-card">
              <div className="industry-icon">
                <i className="fas fa-shopping-basket"></i>
              </div>
              <h3>FMCG</h3>
            </div>
          </div>
        </div>
      </section>

      {/* Projects Section - Moved inside stats section to remove gap */}
      <div className={`projects-section ${isVisible ? 'visible' : ''}`} ref={projectsRef}>
        <div className="container">
          <div className="section-header">
            <h2 className="section-title">Our Project Expertise</h2>
            <p className="section-subtitle">
              Some of the major assignments completed by our team
            </p>
          </div>

          <div className="credentials-tabs">
            <div className="tabs-outer-container">
              <div className="credentials-major-customers-wrapper">
                <div className="tabs-container-images">
                  <div
                    className={`tab-with-image ${activeCard === 1 ? 'active' : ''}`}
                    onClick={() => handleTabClick(1)}
                  >
                    <img 
                      src={require('../../assets/images/capitalization.jpg')}
                      alt="Capitalization of Property Plant & Equipment"
                    />
                    <div className="tab-image-content">
                      <h3 className="tab-image-title">Capitalization of Property Plant & Equipment</h3>
                    </div>
                    <div className="tab-indicator"></div>
                  </div>
                  <div
                    className={`tab-with-image ${activeCard === 2 ? 'active' : ''}`}
                    onClick={() => handleTabClick(2)}
                  >
                    <img 
                      src={require('../../assets/images/asset value.jpg')}
                      alt="Asset Valuation As Per IFRS Requirements"
                    />
                    <div className="tab-image-content">
                      <h3 className="tab-image-title">Asset Valuation As Per IFRS Requirements</h3>
                    </div>
                    <div className="tab-indicator"></div>
                  </div>
                  <div
                    className={`tab-with-image ${activeCard === 3 ? 'active' : ''}`}
                    onClick={() => handleTabClick(3)}
                  >
                    <img 
                      src={require('../../assets/images/residual value.jpg')}
                      alt="Assessment of Useful Life & Residual Value"
                    />
                    <div className="tab-image-content">
                      <h3 className="tab-image-title">Assessment of Useful Life</h3>
                    </div>
                    <div className="tab-indicator"></div>
                  </div>
                  <div
                    className={`tab-with-image ${activeCard === 4 ? 'active' : ''}`}
                    onClick={() => handleTabClick(4)}
                  >
                    <img 
                      src={require('../../assets/images/Physical Verification.jpg')}
                      alt="Audit & Physical Verification"
                    />
                    <div className="tab-image-content">
                      <h3 className="tab-image-title">Audit & Physical Verification</h3>
                    </div>
                    <div className="tab-indicator"></div>
                  </div>
                </div>
                {/* Show sector tabs only when an assignment tab is clicked */}
                {activeCard === 1 && (
                  <div className="major-customers-cards-outer-wrapper">
                    {[
                      {
                        iconClass: 'fas fa-bolt sector-icon power',
                        sector: 'Power Sector',
                        companies: [
                          'SKS Power', 'Essar Power', 'JSW Energy', 'Sterlite Energy', 'DB Power', 'Talwandi Sabo', 'Athena Power', 'Meenakshi Power'
                        ],
                        iconBg: 'power'
                      },
                      {
                        iconClass: 'fas fa-industry sector-icon steel',
                        sector: 'Steel Sector',
                        companies: [
                          'Monnet Ispat', 'Essar Steel', 'JSW Steel', 'Gerdau Steel', 'JSW Projects', 'JSW MI', 'JVML', 'BPSL', 'JSCPL', 'ND Plant'
                        ],
                        iconBg: 'steel'
                      },
                      {
                        iconClass: 'fas fa-solar-panel sector-icon energy',
                        sector: 'Energy Sector',
                        companies: [
                          'Nayara Energy', 'Essar Oil', 'ONGC Petro', 'HMEL'
                        ],
                        iconBg: 'energy'
                      },
                      {
                        iconClass: 'fas fa-cogs sector-icon general',
                        sector: 'General Engineering Sector',
                        companies: [
                          'RFCL', 'Deepak Phenolics', 'BALCO', 'Vizag General Cargo', 'Vadinar Ports', 'HMEL (Pipe Line)', 'AMW', 'Vedanta Aluminium', 'Deepak Chemtech', 'JSW Techno Projects'
                        ],
                        iconBg: 'general'
                      }
                    ].map((sector, idx) => (
                      <div className="major-customer-sector-group" key={sector.sector}>
                          <div className="major-customer-card-header">
                            <span className={`major-customer-card-icon ${sector.iconBg}`}> <i className={sector.iconClass}></i> </span>
                            <span className="major-customer-card-title">{sector.sector}</span>
                        </div>
                        <div className="major-customer-company-cards-wrapper">
                          {sector.companies.map(company => (
                            <div className={`major-customer-company-card card-${sector.iconBg}`} key={sector.sector + '-' + company}>
                              <span className="major-customer-company-name">- {company}</span>
                            </div>
                          ))}
                        </div>
                      </div>
                    ))}
                  </div>
                )}
                {activeCard === 2 && (
                  <div className="major-customers-cards-outer-wrapper">
                    {[
                      {
                        iconClass: 'fas fa-bolt sector-icon power',
                        sector: 'Power Sector',
                        companies: [
                          'Bhander Power', 'EPTCL', 'Essar Power', 'Talwandi Sabo Power', 'Vadinar Power', 'Arcelor Mittal'
                        ],
                        iconBg: 'power'
                      },
                      {
                        iconClass: 'fas fa-industry sector-icon steel',
                        sector: 'Steel Sector',
                        companies: [
                          'JSSL', 'Loha Ispat', 'Essar Steel', 'JSW Steel', 'Kalyani Gerdau', 'JSCPL'
                        ],
                        iconBg: 'steel'
                      },
                      {
                        iconClass: 'fas fa-solar-panel sector-icon energy',
                        sector: 'Energy Sector',
                        companies: [
                          'Nayara Energy'
                        ],
                        iconBg: 'energy'
                      },
                      {
                        iconClass: 'fas fa-cogs sector-icon general',
                        sector: 'General Engineering Sector',
                        companies: [
                          'JSW Infra (CICTPL)', 'Maharaja White Line', 'JSW Infra', 'Vallabh Tin Plate'
                        ],
                        iconBg: 'general'
                      }
                    ].map((sector, idx) => (
                      <div className="major-customer-sector-group" key={sector.sector}>
                          <div className="major-customer-card-header">
                            <span className={`major-customer-card-icon ${sector.iconBg}`}> <i className={sector.iconClass}></i> </span>
                            <span className="major-customer-card-title">{sector.sector}</span>
                        </div>
                        <div className="major-customer-company-cards-wrapper">
                          {sector.companies.map(company => (
                            <div className={`major-customer-company-card card-${sector.iconBg}`} key={sector.sector + '-' + company}>
                              <span className="major-customer-company-name">- {company}</span>
                            </div>
                          ))}
                        </div>
                      </div>
                    ))}
                  </div>
                )}
                {activeCard === 3 && (
                  <div className="major-customers-cards-outer-wrapper">
                    {[
                      {
                        iconClass: 'fas fa-industry sector-icon steel',
                        sector: 'Steel Sector',
                        companies: [
                          'JSW MI', 'JSSL', 'JSCPL', 'JSW Steel', 'NSAIL'
                        ],
                        iconBg: 'steel'
                      },
                      {
                        iconClass: 'fas fa-solar-panel sector-icon energy',
                        sector: 'Energy Sector',
                        companies: [
                          'HMEL', 'VOTL'
                        ],
                        iconBg: 'energy'
                      },
                      {
                        iconClass: 'fas fa-cogs sector-icon general',
                        sector: 'General Engineering Sector',
                        companies: [
                          'EBTL', 'JSW Infra', 'Vadinar Ports', 'JSW SMD'
                        ],
                        iconBg: 'general'
                      }
                    ].map((sector, idx) => (
                      <div className="major-customer-sector-group" key={sector.sector}>
                          <div className="major-customer-card-header">
                            <span className={`major-customer-card-icon ${sector.iconBg}`}> <i className={sector.iconClass}></i> </span>
                            <span className="major-customer-card-title">{sector.sector}</span>
                        </div>
                        <div className="major-customer-company-cards-wrapper">
                          {sector.companies.map(company => (
                            <div className={`major-customer-company-card card-${sector.iconBg}`} key={sector.sector + '-' + company}>
                              <span className="major-customer-company-name">- {company}</span>
                            </div>
                          ))}
                        </div>
                      </div>
                    ))}
                  </div>
                )}
                {activeCard === 4 && (
                  <div className="major-customers-cards-outer-wrapper">
                    {[
                      {
                        iconClass: 'fas fa-bolt sector-icon power',
                        sector: 'Power Sector',
                        companies: [
                          'Udupi Power', 'Essar Power', 'Himachal Baspa', 'REGL (Raigarh)', 'JSW Neo Energy', 'JSW Energy'
                        ],
                        iconBg: 'power'
                      },
                      {
                        iconClass: 'fas fa-industry sector-icon steel',
                        sector: 'Steel Sector',
                        companies: [
                          'JSW Projects', 'JSW Steel', 'JSSL', 'BPSL', 'JSCPL', 'Usha Martin', 'JVML'
                        ],
                        iconBg: 'steel'
                      },
                      {
                        iconClass: 'fas fa-solar-panel sector-icon energy',
                        sector: 'Energy Sector',
                        companies: [
                          'VOTL', 'Essar Oil'
                        ],
                        iconBg: 'energy'
                      },
                      {
                        iconClass: 'fas fa-cogs sector-icon general',
                        sector: 'General Engineering Sector',
                        companies: [
                          'DCW', 'Hindusthan Zinc', 'RFCL', 'Deepak Phenolics'
                        ],
                        iconBg: 'general'
                      }
                    ].map((sector, idx) => (
                      <div className="major-customer-sector-group" key={sector.sector}>
                          <div className="major-customer-card-header">
                            <span className={`major-customer-card-icon ${sector.iconBg}`}> <i className={sector.iconClass}></i> </span>
                            <span className="major-customer-card-title">{sector.sector}</span>
                        </div>
                        <div className="major-customer-company-cards-wrapper">
                          {sector.companies.map(company => (
                            <div className={`major-customer-company-card card-${sector.iconBg}`} key={sector.sector + '-' + company}>
                              <span className="major-customer-company-name">- {company}</span>
                            </div>
                          ))}
                        </div>
                      </div>
                    ))}
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>

      <h2 className="partners-heading">Our Partners</h2>
      <div className="sector-logos-section">
        <div className="sector-logos-grid-wrapper">
          <div className="sector-logos-group">
            <h3 className="sector-logos-title">General Engineering</h3>
            <div className="sector-logos-grid">
              <img src={BALCO} alt="BALCO" />
              <img src={RFCL} alt="RFCL" />
              <img src={VedantaGeneral} alt="Vedanta" />
              <img src={DCWDhangradhra} alt="DCW Dhangradhra" />
              <img src={DeepakPhenolics} alt="Deepak Phenolics" />
              <img src={Maharaja} alt="Maharaja" />
            </div>
          </div>
          <div className="sector-logos-group">
            <h3 className="sector-logos-title">Oil</h3>
            <div className="sector-logos-grid">
              <img src={Nayara} alt="Nayara" />
              <img src={ONGC} alt="ONGC" />
              <img src={HMEL} alt="HMEL" />
              <img src={OPAL} alt="OPAL" />
            </div>
          </div>
          <div className="sector-logos-group">
            <h3 className="sector-logos-title">Power</h3>
            <div className="sector-logos-grid">
              <img src={DBPower} alt="DB Power" />
              <img src={Adani} alt="Adani" />
              <img src={JSWEnergy} alt="JSW Energy" />
              <img src={TSPL} alt="TSPL" />
            </div>
          </div>
          <div className="sector-logos-group">
            <h3 className="sector-logos-title">Steel</h3>
            <div className="sector-logos-grid">
              <img src={EssarSteel} alt="Essar Steel" />
              <img src={ArcelorMittal} alt="Arcelor Mittal" />
              <img src={BPSL} alt="BPSL" />
              <img src={UshaMartinSteel} alt="Usha Martin" />
              <img src={JSWSteel} alt="JSW Steel" />
            </div>
          </div>
        </div>
      </div>

      {/* Journey Navigation - Next Page CTA */}
      <NextPageCTA 
        title="Get In Touch" 
        description="Ready to start your project? Reach out to our team for personalized solutions and expert consultation tailored to your specific needs."
        nextPage={{
          path: "/contact",
          label: "Contact Us Now"
        }}
        headingText="LAST STEP OF OUR JOURNEY"
      />
      <Footer />
    </div>
  );
};

export default Credentials;